// The tab bar's size, apart from the bar itself so layouts can clear it
// without importing the bar (and its session and notification hooks).
export const BOTTOM_TAB_BAR_HEIGHT = 56;

/**
 * Bottom clearance under the tab bar. The full safe-area inset (34px on
 * Face ID iPhones) leaves a dead band above the home indicator, so the bar
 * deliberately extends 12px into the safe zone — standard iOS tab-bar
 * posture — while max() keeps it at 0 on devices with no inset.
 */
export const BOTTOM_TAB_BAR_SAFE_AREA = "max(calc(env(safe-area-inset-bottom, 0px) - 12px), 0px)";
